import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutManagerComponent } from './layout-manager.component';
const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: '', component: LayoutManagerComponent, children:[
      {
        path: '',
        loadChildren: () =>
          import('../modules/profile-module/profile-module.module').then((m)=> m.ProfileModuleModule),
      },
      {
        path: 'rfq',
        loadChildren: () =>
          import('../modules/rfq/rfq.module').then((m)=> m.RfqModule),
      },
      {
        path:'oms',
        loadChildren:() =>
          import('../modules/oms/oms.module').then((m)=> m.OmsModule)
      },
    ]}
  ])],
  exports: [RouterModule]
})
export class LayoutManagerRoutingModule { }
